import { nullSafeGet } from '../utils/DataAccessUtils';

export const selectViewById = (state, viewId?: string) => {
	if (!viewId) return undefined;

	const defaultView = state.session.defaultView;
	if (defaultView && String(defaultView.id) === String(viewId)) {
		return defaultView;
	}

	return nullSafeGet(`saved_filter_views.records.${viewId}`, state);
};
